exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-chip--chip--1nDgbYRY {\n  padding-left: 0px!important;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.image-chip--chip--1nDgbYRY img {\n  margin-right: 2px;\n}\n\n.image-chip--image--3eHhhUSL {\n  border-radius: 5px;\n  vertical-align: middle;\n  height: 32px;\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/image-chip.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;CAChC;;AAED;EACE,kBAAkB;CACnB;;AAED;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;CACd","file":"image-chip.css","sourcesContent":[".chip {\n  padding-left: 0px!important;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n\n.chip img {\n  margin-right: 2px;\n}\n\n.image {\n  border-radius: 5px;\n  vertical-align: middle;\n  height: 32px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"chip": "image-chip--chip--1nDgbYRY",
	"image": "image-chip--image--3eHhhUSL"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/image-chip.css
// module id = 2543
// module chunks = 4